import { IRequestContext } from '@msdyn365-commerce/core';
import { useCallback, useEffect } from 'react';
import { removeCookieFromContext } from '../../../shared/functions/cookie';
import { LEGACY_CONTROLLER_ID_COOKIE_NAME, UC_SERVICES } from '../const';
import { useUserCentricsService } from './useUserCentricsService';

export const useSetControllerIdCookies = (request: IRequestContext) => {
    const userCentricsService = useUserCentricsService(request);

    const setControllerIdCookie = useCallback(async () => {
        if (!userCentricsService.hasLoaded()) {
            return;
        }

        const controllerId = await userCentricsService.getControllerId();

        UC_SERVICES.forEach(service => {
            if (controllerId) {
                userCentricsService.setServiceControllerIdCookie(service.serviceName, service.cookieName, controllerId);
            } else {
                userCentricsService.removeServiceControllerIdCookie(service.cookieName);
            }
        });

        // TODO: Remove this once the legacy cookie has been phased out
        removeCookieFromContext(LEGACY_CONTROLLER_ID_COOKIE_NAME, request);
    }, [userCentricsService, request]);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        setControllerIdCookie();

        window.addEventListener('ucEvent', setControllerIdCookie);
        return () => {
            window.removeEventListener('ucEvent', setControllerIdCookie);
        };
    }, [setControllerIdCookie]);
};
